export default __webpack_public_path__ + "static/media/05-Facebook.a51edd61.png";